var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadCutter = function SvgFadCutter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M70.526 8.975 68.86 187.58l56.214 57.392L215.553 155z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "m85.246 47 1.018 134.104L125.74 223l55.346-55.78-54.06-54.22 11.872-12.917z"
  }))));
};
export { SvgFadCutter as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-cutter.3fb9fa1d.svg";